<aside class="admin-sidebar ynex-sidebar" [class.collapsed]="!isOpen" [class.mobile-open]="isMobileOpen">
  @if (isMobileOpen) {
    <div class="sidebar-mobile-header">
      <span class="mobile-title">Menu</span>
      <button type="button" class="sidebar-close-btn" (click)="closeMobile.emit()" title="Fermer">
        <i name="cross" [size]="14" [color]="'#fff'" Icons></i>
      </button>
    </div>
  }

  <app-sidebar-brand [collapsed]="!isOpen" brandName="PKG Super Admin" />

  <nav class="sidebar-nav">
    @if (canSeeDashboard) {
      <a class="sidebar-home" routerLink="/admin/dashboard" routerLinkActive="sidebar-home--active"
        [routerLinkActiveOptions]="{ exact: true }" [attr.title]="isOpen ? null : 'Tableau de bord'" (click)="closeMobile.emit()">
        <i name="home" [size]="10" [color]="'#fff'" Icons></i>
        @if (isOpen) { <span>Tableau de bord</span> }
      </a>
    }

    <!-- Blocs de couleur (30/10/2026) : Gestion, Commercial, Plateforme. -->
    @for (block of menuBlocks; track block.section) {
      <div class="sidebar-block" [attr.data-section]="block.section">
        @if (isOpen && block.section) {
          <p class="sidebar-block__title">{{ block.section }}</p>
        }
        @for (group of block.groups; track group.label) {
          <app-sidebar-menu-group
            [groupLabel]="group.label"
            [items]="group.items"
            [sidebarCollapsed]="!isOpen"
            [defaultOpen]="isGroupOpenByDefault(group.label)"
            (itemClick)="closeMobile.emit()"
            (itemHover)="onItemHover($event)"
            (itemLeave)="onItemLeave()" />
        }
      </div>
    }
  </nav>

  <app-sidebar-footer [collapsed]="!isOpen" (logout)="onLogout()" />

  @if (!isOpen) {
    <div class="sidebar-hover-tooltip" [class.visible]="hoverTooltipVisible" [style.left.px]="sidebarWidth" [style.top.px]="hoverTooltipY">
      {{ hoverTooltipText }}
    </div>
  }
</aside>
